import {signal} from '@angular/core'
import {TCollectionType} from '../0-application/types'

export interface ICollectionBase {
  active: boolean,
  owner: string,
  balance: number
  isNew?: boolean
}

export class Base<T extends ICollectionBase> {
  /**
   * All subclasses should set this to an ICollection...
   * This is work in progress. But shall be used to be able
   * to filter all collections.
   */
  public collection: TCollectionType | 'base' = 'base'

  public active = signal(true)
  public balance = signal<number>(0)
  public monthly = signal<number>(0)
  public name = signal('')
  /**
   * All subclasses _should_ use this to set the identifier.
   */
  public product = signal('')
  /**
   * The owner is the sub is the personnummer and cannot mutate.
   */
  public owner: string

  /**
   * Set this to true if you create the item in the UI. This
   * make it possible to delete the item. The item will be deleted
   * by object reference.
   */
  public isNew? = false

  constructor(input: { active?: boolean, isNew?: boolean }, owner: string) {
    if ('active' in input) {
      this.active.set(input.active!)
    }
    this.owner = owner
    this.isNew = input.isNew
  }

  public toPlainObject(): T {
    return {active: this.active(), isNew: this.isNew, owner: this.owner} as T
  }
}
